import React from 'react';
import { usePageTitle } from 'hooks';
import { Layout } from 'antd';
import UserListingTable from './UserListingTable';
import ReportLayout from 'views/SkyBox/Insights/Reports/ReportLayout';
import { ReportLayout as StubHubReportLayout } from 'views/StubHub';
import { useAppSelector } from 'app/hooks';
import { dataSource } from 'models/Slices/GlobalSlice';

const Users: React.FC = () => {
  usePageTitle('User Management');
  const DataSource = useAppSelector(dataSource);

  const layoutComponents = {
    skyBox: ReportLayout,
    stubHub: StubHubReportLayout,
  } as const;

  const LayoutComponent = layoutComponents[DataSource] || ReportLayout;

  const userContent = (
    <Layout className="mainInnerLayout reduceTopSpace pb-0">
      <UserListingTable />
    </Layout>
  );

  return (
    <React.Fragment>
      <div className="mainHeading">
        <div>
          <h2>User Management</h2>
        </div>
      </div>
      <LayoutComponent>{userContent}</LayoutComponent>
    </React.Fragment>
  );
};

export default Users;
